<template>
  <h3 class="activeR">我的态度</h3>
  <div style="overflow-y: hidden">
    <div
      class="information_box"
      style="overflow: auto"
      v-infinite-scroll="load"
    >
      <el-card v-for="(item, index) in news_l" :key="index" class="cuP">
        <div class="information">
          <div class="information_l" @click="fnJumpDetailsPage(item.news_id)">
            <el-image :src="`http://oss.deyity.com/img${item.cover_path}`">
              <template #error>
                <el-empty :image-size="50" description="空"></el-empty>
              </template>
            </el-image>
          </div>
          <div class="information_r">
            <h3 @click="fnJumpDetailsPage(item.news_id)">{{ item.title }}</h3>
            <p
              @click="fnJumpDetailsPage(item.news_id)"
              class="conter_s"
              v-html="item.content"
            ></p>
            <p class="pp">
              <span>{{ item.public_time }}({{ item.reprinted }})</span>
              <span class="pp_span">
                <!-- <span><i class="el-icon-s-promotion"></i>转发</span> -->
                <!-- <span
                ><i
                  class="el-icon-star-on"
                  style="font-size: 16px"
                  :style="{ color: item.is_collect ? '#e6a23c' : '' }"
                ></i
                >收藏{{
                  item.collect_num == 0 ? '' : `(${item.collect_num})`
                }}</span
              > -->
              </span>
            </p>
          </div>
        </div>
      </el-card>
      <p v-if="loading" class="loading">加载中...</p>
      <p v-if="noMore" class="loading">没有更多了</p>
    </div>
  </div>
</template>
<script>
import { ref, getCurrentInstance, onUnmounted } from "vue";
import { useRouter } from "vue-router";
export default {
  props: ["AUTH_OBJ", "token"],
  setup() {
    let { proxy: _this } = getCurrentInstance();
    let router = useRouter();
    // let team_id = router.currentRoute.value.params.team_id
    // 初始全部新闻
    let news_l = ref([]);
    let pages = ref(1);
    let loading = ref(true);
    let noMore = ref(false);
    let soccer_news = async () => {
      let { data: res } = await _this.$http.get(
        "/auth/user/collect_news_list",
        {
          params: { page: pages.value },
        }
      );
      res.data.forEach((item) => {
        item.content = item.content
          .replace(/href/g, "aaa")
          .replace(/img src=/g, "aaa");
      });
      news_l.value = news_l.value.concat(...res.data);
      if (res.data.length === 0) {
        loading.value = false;
        noMore.value = true;
        _this.$notify({
          title: "提示",
          message: "已加载全部内容",
          type: "error",
        });
      }
    };
    // soccer_news()
    // 无限滚动
    const load = () => {
      soccer_news();
      pages.value++;
    };
    // 跳转详情页
    let fnJumpDetailsPage = (new_id) => {
      let routeUrl = router.resolve({
        path: `/new/detail/2/${new_id}`,
      });
      window.open(routeUrl.href, "_blank");
    };
    // 关闭定时器
    onUnmounted(() => {
      // window.removeEventListener('scroll', onscrolla)
    });
    return {
      news_l,
      fnJumpDetailsPage,
      load,
      loading,
      noMore,
    };
  },
};
</script>
<style scoped lang="less">
h3 {
  margin-bottom: 10px;
  font-weight: 600;
}
.el-card {
  // width: 1100px;
  margin: 10px auto;
  // margin: 10px 0;
  .information {
    display: flex;
    justify-content: space-between;
    align-items: center;
    &:hover h3 {
      color: #409eff;
    }
    &:hover .conter_s {
      color: #606266;
    }
    .information_l {
      width: 15%;
      height: 100px;
      border-radius: 10px;
      overflow: hidden;
      .el-image {
        width: 100%;
        height: 100%;
      }
      .el-empty {
        width: 100%;
        height: 100px;
        background-color: rgba(0, 0, 0, 0.1);
      }
    }
    .information_r {
      width: 83%;
      height: 100px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      h3 {
        font-weight: 600;
        width: 100%;
        display: -webkit-box; /**对象作为伸缩盒子模型展示**/
        -webkit-box-orient: vertical; /**设置或检索伸缩盒子对象的子元素的排列方式**/
        -webkit-line-clamp: 1; /**显示的行数**/
      }
      .conter_s {
        height: 20px;
        overflow: hidden;
        display: -webkit-box; /**对象作为伸缩盒子模型展示**/
        -webkit-box-orient: vertical; /**设置或检索伸缩盒子对象的子元素的排列方式**/
        -webkit-line-clamp: 1; /**显示的行数**/
        padding: 10px;
        line-height: 26px;
        background: #eee;
      }
    }
  }
  .pp {
    display: flex;
    justify-content: space-between;
    font-size: 12px;
    color: #8c8c8c;
    font-weight: 600;
    .pp_span {
      span {
        margin: 0 10px;
      }
    }
  }
}
.information_box::-webkit-scrollbar {
  width: 4px;
  /*height: 4px;*/
}
.information_box::-webkit-scrollbar-thumb {
  border-radius: 10px;
  -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  background: rgba(0, 0, 0, 0.2);
}
.information_box::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  border-radius: 0;
  background: rgba(0, 0, 0, 0.1);
}
.information_box {
  height: 600px;
}
.loading {
  color: #8c8c8c;
  font-size: 14px;
  height: 50px;
  line-height: 50px;
  text-align: center;
}
</style>
